"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CapgoCapacitorDataStorageSqlite = void 0;
const Data_1 = require("./electron-utils/Data");
const StorageDatabaseHelper_1 = require("./electron-utils/StorageDatabaseHelper");
const json_utils_1 = require("./electron-utils/json-utils");
class CapgoCapacitorDataStorageSqlite {
    constructor() {
        this.mDb = new StorageDatabaseHelper_1.StorageDatabaseHelper();
    }
    async echo(options) {
        const ret = {};
        ret.value = options.value ? options.value : "";
        return Promise.resolve(ret);
    }
    async openStore(options) {
        const dbName = options.database
            ? `${options.database}SQLite.db`
            : "storageSQLite.db";
        const tableName = options.table ? options.table : "storage_store";
        try {
            await this.mDb.openStore(dbName, tableName);
            return Promise.resolve();
        }
        catch (err) {
            return Promise.reject(err);
        }
    }
    async closeStore(options) {
        const dbName = options.database
            ? `${options.database}SQLite.db`
            : "storageSQLite.db";
        if (this.mDb.dbName === dbName && this.mDb.isOpen) {
            try {
                await this.mDb.closeStore(dbName);
                return Promise.resolve();
            }
            catch (err) {
                return Promise.reject(err);
            }
        }
        else {
            return Promise.resolve();
        }
    }
    async isStoreOpen(options) {
        const dbName = options.database
            ? `${options.database}SQLite.db`
            : "storageSQLite.db";
        let ret = false;
        if (this.mDb.dbName === dbName && this.mDb.isOpen) {
            ret = true;
        }
        return Promise.resolve({ result: ret });
    }
    async isStoreExists(options) {
        const dbName = options.database
            ? `${options.database}SQLite.db`
            : "storageSQLite.db";
        let ret = false;
        try {
            ret = await this.mDb.isStoreExists(dbName);
            return Promise.resolve({ result: ret });
        }
        catch (err) {
            return Promise.reject(err);
        }
    }
    async setTable(options) {
        const tableName = options.table;
        if (tableName == null) {
            return Promise.reject("Must provide a table name");
        }
        try {
            await this.mDb.setTable(tableName);
            return Promise.resolve();
        }
        catch (err) {
            return Promise.reject("Must open a store first");
        }
    }
    async set(options) {
        const key = options.key;
        if (key == null) {
            return Promise.reject("Must provide key");
        }
        const value = options.value;
        if (value == null) {
            return Promise.reject("Must provide value");
        }
        const data = new Data_1.Data();
        data.name = key;
        data.value = value;
        try {
            await this.mDb.set(data);
            return Promise.resolve();
        }
        catch (err) {
            return Promise.reject(err);
        }
    }
    async get(options) {
        let ret;
        const key = options.key;
        if (key == null) {
            return Promise.reject("Must provide key");
        }
        try {
            const data = await this.mDb.get(key);
            ret = (data === null || data === void 0 ? void 0 : data.id) != null ? data.value : "";
            return Promise.resolve({ value: ret });
        }
        catch (err) {
            return Promise.reject(err);
        }
    }
    async remove(options) {
        try {
            const key = options.key;
            if (key == null) {
                return Promise.reject("Must provide key");
            }
            await this.mDb.remove(key);
            return Promise.resolve();
        }
        catch (err) {
            return Promise.reject(err);
        }
    }
    async clear() {
        try {
            await this.mDb.clear();
            return Promise.resolve();
        }
        catch (err) {
            return Promise.reject(err);
        }
    }
    async iskey(options) {
        let ret;
        const key = options.key;
        if (key == null) {
            return Promise.reject("Must provide key");
        }
        try {
            ret = await this.mDb.iskey(key);
            return Promise.resolve({ result: ret });
        }
        catch (err) {
            return Promise.reject(err);
        }
    }
    async keys() {
        try {
            const ret = await this.mDb.keys();
            return Promise.resolve({ keys: ret });
        }
        catch (err) {
            return Promise.reject(err);
        }
    }
    async values() {
        try {
            const ret = await this.mDb.values();
            return Promise.resolve({ values: ret });
        }
        catch (err) {
            return Promise.reject(err);
        }
    }
    async filtervalues(options) {
        const filter = options.filter;
        if (filter == null || typeof filter != "string") {
            return Promise.reject("Must Must provide filter as string");
        }
        try {
            const ret = await this.mDb.filtervalues(filter);
            return Promise.resolve({ values: ret });
        }
        catch (err) {
            return Promise.reject(err);
        }
    }
    async keysvalues() {
        const ret = [];
        try {
            const results = await this.mDb.keysvalues();
            for (const result of results) {
                const res = { key: result.name, value: result.value };
                ret.push(res);
            }
            return Promise.resolve({ keysvalues: ret });
        }
        catch (err) {
            return Promise.reject(err);
        }
    }
    async deleteStore(options) {
        let dbName = options.database;
        if (dbName == null) {
            return Promise.reject("Must provide a Database Name");
        }
        dbName = `${options.database}SQLite.db`;
        try {
            await this.mDb.deleteStore(dbName);
            return Promise.resolve();
        }
        catch (err) {
            return Promise.reject(err);
        }
    }
    async isTable(options) {
        const table = options.table;
        if (table == null) {
            return Promise.reject("Must provide a Table Name");
        }
        try {
            const ret = await this.mDb.isTable(table);
            return Promise.resolve({ result: ret });
        }
        catch (err) {
            return Promise.reject(err);
        }
    }
    async tables() {
        try {
            const ret = await this.mDb.tables();
            return Promise.resolve({ tables: ret });
        }
        catch (err) {
            return Promise.reject(err);
        }
    }
    async deleteTable(options) {
        const table = options.table;
        if (table == null) {
            return Promise.reject("Must provide a Table Name");
        }
        try {
            await this.mDb.deleteTable(table);
            return Promise.resolve();
        }
        catch (err) {
            return Promise.reject(err);
        }
    }
    async importFromJson(options) {
        const keys = Object.keys(options);
        if (!keys.includes("jsonstring")) {
            return Promise.reject("Must provide a json object");
        }
        let totalChanges = 0;
        if (options === null || options === void 0 ? void 0 : options.jsonstring) {
            const jsonStrObj = options.jsonstring;
            const jsonObj = JSON.parse(jsonStrObj);
            const isValid = (0, json_utils_1.isJsonStore)(jsonObj);
            if (!isValid) {
                return Promise.reject("Must provide a valid JsonSQLite Object");
            }
            const vJsonObj = jsonObj;
            const dbName = vJsonObj.database
                ? `${vJsonObj.database}SQLite.db`
                : "storageSQLite.db";
            for (const table of vJsonObj.tables) {
                const tableName = table.name ? table.name : "storage_store";
                try {
                    // Open the database
                    await this.mDb.openStore(dbName, tableName);
                    // Import the JsonSQLite Object
                    if (table === null || table === void 0 ? void 0 : table.values) {
                        const changes = await this.mDb.importJson(table.values);
                        totalChanges += changes;
                    }
                }
                catch (err) {
                    return Promise.reject(`ImportFromJson: ${err}`);
                }
                finally {
                    await this.mDb.closeStore(dbName);
                }
            }
            return Promise.resolve({ changes: totalChanges });
        }
        else {
            return Promise.reject("Must provide a json object");
        }
    }
    async isJsonValid(options) {
        const keys = Object.keys(options);
        if (!keys.includes("jsonstring")) {
            return Promise.reject("Must provide a json object");
        }
        if (options === null || options === void 0 ? void 0 : options.jsonstring) {
            const jsonStrObj = options.jsonstring;
            const jsonObj = JSON.parse(jsonStrObj);
            const isValid = (0, json_utils_1.isJsonStore)(jsonObj);
            if (!isValid) {
                return Promise.reject("Stringify Json Object not Valid");
            }
            else {
                return Promise.resolve({ result: true });
            }
        }
        else {
            return Promise.reject("Must provide in options a stringify Json Object");
        }
    }
    async exportToJson() {
        try {
            const ret = await this.mDb.exportJson();
            return Promise.resolve({ export: ret });
        }
        catch (err) {
            return Promise.reject(`exportToJson: ${err.message}`);
        }
    }
}
exports.CapgoCapacitorDataStorageSqlite = CapgoCapacitorDataStorageSqlite;
//# sourceMappingURL=index.js.map